import React, { useEffect, useState, useCallback, useRef } from "react";
import FilterIcon from "../../icons/FilterIcon";
import Search from "../../icons/Search";
import Add from "../../icons/Add";
import Modal from "react-modal";
import { countries } from "../shared/countrySelectInput/countries";
import AddUserForm from "../admins/addUser";
import { useMyContext } from "../../context/MyContext";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.79)",
    zIndex: 100,
  },
};

const UserHeader = ({ filteredData, setFilteredData, Data }) => {
  const { user } = useMyContext();
  const canAddUser = ["super admin", "admin", "managing admin"].includes(user?.role);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [dropdown, setDropdown] = React.useState(false);
  const [openUserModel, setOpenUserModel] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [filteredOptions, setFilteredOptions] = React.useState([]);
  const dropdownRef = useRef(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps



  const FilterData = useCallback(() => {
    if (!Data || Data.length === 0) {
      setFilteredData([]);
      return;
    }

    let filtered = Data;

    if (searchQuery.trim() !== "") {
      filtered = filtered.filter((directory) =>
        Object.values(directory).some(
          (value) =>
            typeof value === "string" &&
            value.toLowerCase().includes(searchQuery.toLowerCase())
        )
      );
    }

    if (selectedCountry) {
      filtered = filtered.filter((directory) =>
        directory.country &&
        typeof directory.country === "string" &&
        directory.country.toLowerCase().includes(selectedCountry.toLowerCase())
      );
    }

    setFilteredData(filtered);
  }, [Data, searchQuery, selectedCountry, setFilteredData]);

  const countryOptions = countries.map((country) => ({
    value: country,
    label: country,
  }));
  useEffect(() => {
    FilterData();
  }, [FilterData]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const filtered = countryOptions.filter(country =>
      country.value.toLowerCase().includes(selectedCountry.toLowerCase())
    );
    setFilteredOptions(filtered);
  }, [selectedCountry, countryOptions]);

  const handleInputChange = (e) => {
    setSelectedCountry(e.target.value);
    setSearchQuery(e.target.value); //decouple
    setDropdown(true);
  };

  const clearFilters = () => {
    setSelectedCountry("");
    setSearchQuery("");
    setDropdown(false);
    FilterData();
  };

  return (
    <>
      <div
        className="p-5 rounded-[10px] bg-[#fff]"
        style={{ border: "1px solid rgba(5, 63, 146, 0.24)" }}
      >
        {/* Parent Flex  */}
        <div className="flex flex-wrap items-center justify-between space-y-2">
          {/* Filter Button And Search */}
          <div className="flex flex-col items-center w-full md:w-auto gap-y-2 md:flex-row md:space-x-2">
            <div className="relative " ref={dropdownRef}>
              <button
                onClick={() => setDropdown(!dropdown)}
                className="w-full md:w-auto flex rounded-[5px] items-center space-x-3 py-3 px-6 text-white btnBg"
              >
                <FilterIcon />
                <p>Filters</p>
              </button>
              {/* {dropdown && */}
              <div
                id="dropdown-menu"
                className={` h-[50vh] w-60 overflow-y-auto  z-30 absolute left-0 mt-2 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 p-1 space-y-1 ${dropdown ? "" : "hidden"
                  }`}
              >
                <input
                  id="search-input"
                  className="block w-full px-4 py-2 text-gray-800 rounded-md focus:outline-none"
                  style={{ border: '2px solid #3b82f6' }}
                  type="text"
                  placeholder="Search directories"
                  autoComplete="off"
                  value={selectedCountry}
                  onChange={handleInputChange}
                />
                {/* Clear button */}
                <div
                  className="flex items-center justify-between px-4 py-2 cursor-pointer hover:bg-gray-100 text-red-500"
                  onClick={clearFilters}
                >
                  Clear Filters
                </div>
                {filteredOptions.map((country, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between px-4 py-2 cursor-pointer hover:bg-gray-100"
                    // eslint-disable-next-line no-unused-expressions
                    onClick={() => {
                      setSelectedCountry(country.value);
                      setSearchQuery(country.value); //decouple  
                      setDropdown(false);
                      FilterData();
                    }}
                  >
                    <div>{country?.value} </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="w-full md:w-auto p-3 flex space-x-2 items-center border border-blue rounded-[5px]">
              <Search />
              <input
                placeholder="Search here"
                className="outline-none w-full"
                type="text"
                name=""
                id=""
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  FilterData();
                }}
                style={{ color: "rgba(24, 24, 35, 0.53)" }}
              />
            </div>
          </div>

          {/* Add Admin Button */}
          {/* <div
            onClick={() => setIsOpen(true)}
            className="w-full md:w-auto flex cursor-pointer space-x-2 py-3 px-6 bg-[#DA1C00] rounded-[5px]"
          >
            <div className="h-[24px] w-[24px] bg-[#fff] rounded-full flex justify-center items-center">
              <Add />
            </div>
            <p className="text-[#fff]">Add Users</p>
          </div> */}

          {canAddUser ? (
            <div
              onClick={() => setOpenUserModel(true)}
              className="w-full md:w-auto flex cursor-pointer space-x-2 py-3 px-6 btnBg rounded-[5px]"
            >
              {/* Add icon */}
              <div className="h-[24px] w-[24px] bg-[#fff] rounded-full flex justify-center items-center">
                <Add />
              </div>
              <p className="text-[#fff]">Add User</p>
            </div>
          ) : null}
        </div>
      </div>

      {/* Modal */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => setIsOpen(false)}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <h1 className="text-[#000] font-semibold text-[24px]">Add User</h1>

        <form className="mt-3 md:w-[500px]">
          <input
            type="text"
            placeholder="Enter Name"
            className="px-3 py-2 rounded-[10px] my-3 focus:outline-none w-full"
            style={{
              border: "1px solid #053F92",
              color: "rgba(5, 63, 146, 0.45)",
            }}
            name=""
            id=""
          />
          <input
            type="email"
            placeholder="Enter Email"
            className="px-3 py-2 rounded-[10px] my-3 focus:outline-none w-full"
            style={{
              border: "1px solid #053F92",
              color: "rgba(5, 63, 146, 0.45)",
            }}
            name=""
            id=""
          />
          <input
            type="password"
            placeholder="Enter Password"
            className="px-3 py-2 rounded-[10px] my-3 focus:outline-none w-full"
            style={{
              border: "1px solid #053F92",
              color: "rgba(5, 63, 146, 0.45)",
            }}
            name=""
            id=""
          />

          {/* Submit Button */}
          <div className="flex justify-end mt-1">
            <button className="px-5 py-2 bg-[#053F92] rounded-[5px] text-[#fff]">
              Add
            </button>
          </div>
        </form>
      </Modal>

      <Modal
        isOpen={openUserModel}
        onRequestClose={() => setOpenUserModel(false)}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <AddUserForm setOpenUserModel={setOpenUserModel} />
      </Modal>
    </>
  );
};

export default UserHeader;
